import { render, staticRenderFns } from "./AppHeaderLogo.vue?vue&type=template&id=397247e2&scoped=true&"
import script from "./AppHeaderLogo.vue?vue&type=script&lang=js&"
export * from "./AppHeaderLogo.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderLogo.vue?vue&type=style&index=0&id=397247e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397247e2",
  null
  
)

export default component.exports